







































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import GroupsProgramDetails from "./GroupsProgramDetails.vue";

import GroupBookingProgramJson from "../../shared/GroupBookingProgramJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

export default Vue.extend({
  name: "GroupsPrograms",
  components: {
    Loading,
    GroupsProgramDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      showDetails: false,
      detailsMode: "read",
      allGroupPrograms: null as GroupBookingProgramJson[] | null,
      selectedProgramId: null as number | null,
      selectedProgram: null as GroupBookingProgramJson | null,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.loadData();
      }
    },

    loadData() {
      this.loadGroupPrograms();
    },

    async reloadSelectedProgram() {
      this.selectedProgram = null;
      this.toggleDetails();
      if (this.selectedProgramId != null) {
        try {
          this.allGroupPrograms = await this.restClient.getGroupBookingPrograms();

          //todo: selectedWorkshop filtern
          this.openDetails(this.selectedProgram, "read");
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadGroupPrograms() {
      this.allGroupPrograms = null;
      if (this.restClient != null) {
        try {
          this.allGroupPrograms = await this.restClient.getGroupBookingPrograms();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    openDetails(item: GroupBookingProgramJson | null, mode: string) {
      if (item != null) {
        this.selectedProgramId = item.ID;
        this.selectedProgram = JSON.parse(JSON.stringify(item));
      } else {
        this.selectedProgramId = null;
        this.selectedProgram = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },

    async duplicateGroupProgram(item: GroupBookingProgramJson) {
      let newItem: GroupBookingProgramJson = JSON.parse(JSON.stringify(item));

      this.allGroupPrograms = null;

      newItem.ID = null;
      newItem.title = newItem.title + " Kopie";

      try {
        let duplicatedGroupProgram = await this.restClient.addGroupBookingProgram(newItem);
      } catch (e) {
        alert(e.message);
      }

      this.loadGroupPrograms();
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {},
});
